let API_BASE_URL;

// Check if we're in development
if (process.env.NODE_ENV === 'development') {
  API_BASE_URL = 'http://localhost:8000';  // Backend runs on 8000 locally
} else {
  API_BASE_URL = window.location.origin;   // Same origin in production (port 5000)
}

console.log("API_BASE_URL", API_BASE_URL);

export { API_BASE_URL };
